import { AudioLevelMeter } from '@/entities/audio-recording';

type Props = {
    label: string;
    showLabel?: boolean;
    audioStream?: MediaStream;
    onAudioLevelChange?: (isAudioLevelLow: boolean) => void;
};

export function RecordingCaptureLabeledAudioMeter({
    label,
    showLabel = true,
    audioStream,
    onAudioLevelChange,
}: Props) {
    return (
        <div className="flex flex-col items-center gap-2">
            {showLabel && <p className="text-xs text-muted-foreground">{label}</p>}
            <AudioLevelMeter
                mode="recording"
                label={label}
                audioStream={audioStream}
                onAudioLevelChange={onAudioLevelChange}
            />
        </div>
    );
}
